export const EMPTY_ACTIVITY = { created_source: "", changed_source: "", date_field: "updated", date_from: "", date_to: "", sort: "" };

const SEL = "h-9 rounded-full border border-input bg-background px-3 text-sm";

export function ActivityFilters({ value, onChange }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const dirty = Object.entries(value).some(([k, v]) => v && v !== EMPTY_ACTIVITY[k]);
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm" data-testid="activity-filters">
      <select value={value.created_source} onChange={set("created_source")} className={SEL} data-testid="filter-created-source">
        <option value="">Created by: any</option>
        <option value="manual">Created: manual</option>
        <option value="import">Created: spreadsheet import</option>
        <option value="bulk">Created: bulk add</option>
      </select>
      <select value={value.changed_source} onChange={set("changed_source")} className={SEL} data-testid="filter-changed-source">
        <option value="">Last change: any</option>
        <option value="manual">Last change: manual edit</option>
        <option value="import">Last change: import</option>
        <option value="system">Last change: system</option>
      </select>
      <select value={value.date_field} onChange={set("date_field")} className={SEL} data-testid="filter-date-field">
        <option value="updated">Updated</option>
        <option value="created">Created</option>
      </select>
      <input type="date" value={value.date_from} onChange={set("date_from")} className={SEL} aria-label="From date" data-testid="filter-date-from" />
      <span className="text-muted-foreground">to</span>
      <input type="date" value={value.date_to} onChange={set("date_to")} className={SEL} aria-label="To date" data-testid="filter-date-to" />
      <select value={value.sort} onChange={set("sort")} className={SEL} data-testid="filter-sort">
        <option value="">Sort: Bible order</option>
        <option value="updated_desc">Recently updated</option>
        <option value="created_desc">Recently created</option>
        <option value="updated_asc">Oldest update</option>
        <option value="created_asc">Oldest created</option>
      </select>
      {dirty && <button type="button" onClick={() => onChange(EMPTY_ACTIVITY)} className="text-xs text-muted-foreground underline hover:text-foreground" data-testid="filter-activity-clear">Clear</button>}
    </div>
  );
}
